<template>
  <div>
    <h1>Heroes Combination Checker</h1>

    <div class="alert alert-secondary d-flex justify-content-center" role="alert">
      <a class="btn btn-primary" href="/roe-heroes/old-combo-checker" role="button">To Use The Previous Combination Checker, Click Here.</a>
    </div>
    
    <ul class="nav nav-tabs" id="mainTab" role="tablist">
      <li class="nav-item col-6" role="presentation">
        <button class="nav-link w-100 active" id="selections-tab" data-bs-toggle="tab" data-bs-target="#selections" type="button" role="tab" aria-controls="selections" aria-selected="true">
          <h3>Select Your Heroes!</h3>
        </button>
      </li>
      <li class="nav-item col-6" role="presentation">
        <button class="nav-link w-100" id="results-tab" data-bs-toggle="tab" data-bs-target="#results" type="button" role="tab" aria-controls="results" aria-selected="false">
          <h3>View Results!</h3>
        </button>
      </li>
    </ul>
    <div class="tab-content" id="mainTabContent">
      <div class="card tab-pane fade show active" id="selections" role="tabpanel" aria-labelledby="selections-tab">
        <div class="card-header">
          <div class="w-100">
            <label class="me-3">Quick Select:</label>
            <div class="w-auto d-inline me-3 ps-2" style="border-left: 1px solid black">
              <input type="checkbox" v-model="checkboxes.all_heroes" v-bind:checked="checkboxes.all_heroes" style="cursor:pointer">
              <label class="ms-1" style="cursor:pointer" @click="checkboxes.all_heroes = checkboxes.all_heroes ? false : true">(All Heroes)</label>
            </div>
            <div class="w-auto d-inline me-3 ps-2" style="border-left: 1px solid black" v-for="(theHeroes, heroType) in heroes">
              <input type="checkbox" v-model="checkboxes[heroType]" v-bind:checked="checkboxes[heroType]" @click="setCheckbox(heroType)" style="cursor:pointer">
              <label class="ms-1" style="cursor:pointer" @click="setCheckbox(heroType);checkboxes[heroType] = checkboxes[heroType] ? false : true;">(All {{ heroType.charAt(0).toUpperCase() + heroType.slice(1) }} {{ (heroType==`general`) ? ` Heroes` : `` }})</label>
            </div>
          </div>
          <div class="w-100 mt-2 pt-2" style="border-top: 1px solid black">
            <ul class="nav nav-tabs card-header-tabs" id="heoresTab" role="tablist">
              <li class="nav-item" role="presentation" v-for="(theHeroes, heroType) in heroes">
                <button class="nav-link "
                        :class="(heroType==`general`) ? ` active` : ``" 
                        :id="heroType + `-tab`"
                        data-bs-toggle="tab"
                        :data-bs-target="`#` + heroType"
                        type="button"
                        role="tab"
                        :aria-controls="heroType"
                        :aria-selected="(heroType==`general`) ? `true` : `false`"
                >
                  Show {{ heroType.charAt(0).toUpperCase() + heroType.slice(1) }} {{ (heroType==`general`) ? ` Heroes` : `` }} ({{ selectedHeroes[heroType].length }}/{{ theHeroes.length }})
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div class="card-body tab-content" id="heoresTabContent">
          <div class="tab-pane fade "
               :class="(heroType==`general`) ? ` show active` : ``"
               :id="heroType"
               role="tabpanel"
               :aria-labelledby="heroType + `-tab`"
               v-for="(theHeroes, heroType) in heroes">
            <div class="row">
              <div class="col-sm-4 col-md-2" v-for="hero in theHeroes">
                <div class="card">
                  <img class="card-img-top" :src="`/images/` + hero.image" :alt="parseName(hero.name)"/>
                  <div class="card-body">
                    <div class="card-title row">
                      <span class="col-8 text-start">{{ parseName(hero.name) }}</span>
                      <span class="col-4 text-end">{{ (hero.season!=`none`) ? hero.season.toUpperCase() : `` }}</span>
                    </div>
                    <p class="card-text row">
                      <span class="col-8 text-start">({{ hero.specialty.charAt(0).toUpperCase() + hero.specialty.slice(1) }})</span>
                      <span class="col-4 form-check form-switch align-middle">
                        <input class="form-check-input" style="cursor:pointer" type="checkbox" v-model="selectedHeroes[heroType]" :id="hero.id" :value="hero.id">
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card tab-pane fade" id="results" role="tabpanel" aria-labelledby="results-tab">
        <div class="card-header">
          <ul class="nav nav-tabs card-header-tabs" id="rankingsTab" role="tablist">
            <li class="nav-item" role="presentation" v-for="(theRankings, rankingType) in rankings">
              <button class="nav-link "
                      :class="(rankingType==`archers`) ? ` active` : ``" 
                      :id="rankingType + `-ranking-tab`"
                      data-bs-toggle="tab"
                      :data-bs-target="`#` + rankingType + `-ranking`"
                      type="button"
                      role="tab"
                      :aria-controls="rankingType + `-ranking`"
                      :aria-selected="(rankingType==`archers`) ? `true` : `false`"
              >
                Show {{ rankingType.charAt(0).toUpperCase() + rankingType.slice(1) }} Combos ({{ shownInRanking(rankingType) }})
              </button>
            </li>
          </ul>
        </div>
        <div class="card-body tab-content" id="rankingsTabContent">
          <div class="tab-pane fade "
               :class="(rankingType==`archers`) ? ` show active` : ``"
               :id="rankingType + `-ranking`"
               role="tabpanel"
               :aria-labelledby="rankingType + `-ranking-tab`"
               v-for="(theRankings, rankingType) in rankings">
            <div class="row">
              <div class="col-xl-12 col-xxl-6" 
                   :class="rankingType + `-ranking-legion`"
                   v-for="combo in theRankings" 
                   :key="combo.id" 
                   :data-row1-id="combo.row1.id" 
                   :data-row2-id="combo.row2.id" 
                   :data-row3-id="combo.row3.id" 
                   v-show="isInSelectedHeroes(rankingType, [combo.row1.id, combo.row2.id, combo.row3.id])"
              >
                <div class="card mb-4">
                  <div class="card-header">
                    <h4> Rank {{ combo.rank }}</h4>
                  </div>
                  <div class="card-body d-flex">
                    <div class="col-md-4">
                      <div class="card">
                        <img class="card-img-top" :src="`/images/` + combo.row1.image" :alt="parseName(combo.row1.name)"/>
                        <div class="card-body">
                          <div class="row">
                            <span class="card-text col-md-6 text-start">Front</span>
                            <span class="card-text col-md-6 text-md-end text-start">({{ combo.row1.specialty.charAt(0).toUpperCase() + combo.row1.specialty.slice(1) }})</span>
                          </div>
                          <div class="row">
                            <span class="card-text col-md-8 text-start">"{{ parseName(combo.row1.name) }}"</span>
                            <span class="card-text col-md-4 text-end">{{ (combo.row1.season!=`none`) ? combo.row1.season.toUpperCase() : `` }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card">
                        <img class="card-img-top" :src="`/images/` + combo.row2.image" :alt="parseName(combo.row2.name)"/>
                        <div class="card-body">
                          <div class="row">
                            <span class="card-text col-md-6 text-start">Middle</span>
                            <span class="card-text col-md-6 text-md-end text-start">({{ combo.row2.specialty.charAt(0).toUpperCase() + combo.row2.specialty.slice(1) }})</span>
                          </div>
                          <div class="row">
                            <span class="card-text col-md-8 text-start">"{{ parseName(combo.row2.name) }}"</span>
                            <span class="card-text col-md-4 text-end">{{ (combo.row2.season!=`none`) ? combo.row2.season.toUpperCase() : `` }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card">
                        <img class="card-img-top" :src="`/images/` + combo.row3.image" :alt="parseName(combo.row3.name)"/>
                        <div class="card-body">
                          <div class="row">
                            <span class="card-text col-md-6 text-start">Back</span>
                            <span class="card-text col-md-6 text-md-end text-start">({{ combo.row3.specialty.charAt(0).toUpperCase() + combo.row3.specialty.slice(1) }})</span>
                          </div>
                          <div class="row">
                            <span class="card-text col-md-8 text-start">"{{ parseName(combo.row3.name) }}"</span>
                            <span class="card-text col-md-4 text-end">{{ (combo.row3.season!=`none`) ? combo.row3.season.toUpperCase() : `` }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    heroesData: {
      type: String,
      default: "{}"
    },
    rankingsData: {
      type: String,
      default: "{}"
    }
  },
  data() {
    return {
      heroes: this.getHeroes(),
      rankings: this.getRankings(),
      checkboxes: {
        all_heroes: false,
        general: false,
        archers: false,
        footmen: false,
        cavalries: false
      },
      checkboxChangeAll: null,
      checkboxSingleChange: false,
      selectedHeroes: {
        general: [],
        archers: [],
        cavalries: [],
        footmen: []
      }
    };
  },
  methods: {
    getHeroes() {
      return JSON.parse(this.heroesData);
    },
    getRankings() {
      return JSON.parse(this.rankingsData);
    },
    setCheckbox(key) {
      if (this.checkboxes[key]) {
        this.checkboxChangeAll = false;
        this.checkboxes.all_heroes = false;
        this.selectedHeroes[key] = [];
      } else {
        this.selectedHeroes[key] = this.heroes[key].map(hero => hero.id)
        let otherCheckboxesIsTrue = 0;
        for (let index in this.checkboxes) {
          if (index!='all_heroes' && index!=key && this.checkboxes[index]) {
            otherCheckboxesIsTrue++;
          }
        }
        if (otherCheckboxesIsTrue==3) {
          this.checkboxChangeAll = false;
          this.checkboxes.all_heroes = true;
        }
      }
    },
    parseName(name) {
      let arr = name.split(" ");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }
      return arr.join(" ");
    },
    isInSelectedHeroes(rankingType, ids) {
      let heroExists = 0;
      if (rankingType=='archers') {
        ids.forEach((id) => {
          if (this.selectedHeroes.general.includes(id) || this.selectedHeroes.archers.includes(id)) {
            heroExists++;
          }
        });
      } else if (rankingType=='cavalries') {
        ids.forEach((id) => {
          if (this.selectedHeroes.general.includes(id) || this.selectedHeroes.cavalries.includes(id)) {
            heroExists++;
          }
        });
      } else if (rankingType=='footmen') {
        ids.forEach((id) => {
          if (this.selectedHeroes.general.includes(id) || this.selectedHeroes.footmen.includes(id)) {
            heroExists++;
          }
        });
      } else if (rankingType=='mixes' || rankingType=='poisonTiles') {
        ids.forEach((id) => {
          if (this.selectedHeroes.general.includes(id) || this.selectedHeroes.archers.includes(id) || this.selectedHeroes.cavalries.includes(id) || this.selectedHeroes.footmen.includes(id)) {
            heroExists++;
          }
        });
      }

      return heroExists==3 ? true : false;
    },
    shownInRanking(rankingType) {
      let count = 0;
      [...document.getElementsByClassName(rankingType + `-ranking-legion`)].forEach(function(element) {
        if (element.style.display!='none') {
          count++
        }
      });

      return count;
    }
  },
  watch: {
    "checkboxes.all_heroes": function(newValue, oldValue) {
      let _this = this;
      setTimeout(function() {
        if (_this.checkboxChangeAll===null) {
          _this.checkboxChangeAll = true;
        }
        if (_this.checkboxChangeAll) {
          if (_this.checkboxes.all_heroes) {
            _this.setCheckbox('general');
            _this.checkboxes.general = true;
            _this.setCheckbox('archers');
            _this.checkboxes.archers = true;
            _this.setCheckbox('footmen');
            _this.checkboxes.footmen = true;
            _this.setCheckbox('cavalries');
            _this.checkboxes.cavalries = true;
          } else {
            _this.setCheckbox('general');
            _this.checkboxes.general = false;
            _this.setCheckbox('archers');
            _this.checkboxes.archers = false;
            _this.setCheckbox('footmen');
            _this.checkboxes.footmen = false;
            _this.setCheckbox('cavalries');
            _this.checkboxes.cavalries = false;
          }
        }
        _this.checkboxChangeAll = null;
      }, 50);
    },
  },
  mounted() {}
}
</script>
